import React, { Component } from 'react';
import { Row } from 'reactstrap';
import ApplicationCard from '../common/ApplicationCard';
import { ICON_PATH } from '../common/constants';
import { Grid } from '@mui/material';

class AppsPanel extends Component {
  render() {
    const apps = this.props.apps;

    return (
      <Row style={{ height: '100%' }} className={this.props.className}>
        <Grid container>
          {apps.map((app) => {
            return (
              <Grid item xs={4} className="mb-2 px-1" key={app.id}>
                <ApplicationCard
                  widgetId="myApps"
                  app={app}
                  data={{ icon: ICON_PATH + app?.icon }}
                  isActive={true}
                  showHeart={false}
                  showInfo={false}
                  showLinks={true}
                  showReorder={false}
                  isMyApps={this.props.isMyApps}
                />
              </Grid>
            );
          })}
        </Grid>
      </Row>
    );
  }
}

export default AppsPanel;
